import flagUS from '../assets/images/flag-us-round.png';
import flagSpain from '../assets/images/flag-spain-round.png';

const listLangue = [
  {
    key: 'en-US',
    name: 'English',
    flag: flagUS,
  },
  {
    key: 'es',
    name: 'Español',
    flag: flagSpain,
  },
];

const itemLangSelected = key => {
  const item = listLangue.find(item => item.key === key);
  return item || listLangue[0];
};

const listLangNotSelect = key => {
  const item = listLangue.filter(val => val.key !== key);
  return item;
};

export { itemLangSelected, listLangNotSelect };
